import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GraphQLClient } from "../../../shared/gql-client";
import { EventStatus } from "../domain/models/EventModel";
import * as gqlBuilder from "gql-query-builder";
import { gql } from "@apollo/client";
import { EventModel } from "../domain/schema/eventSchema";

export const updateEventStatus = createAsyncThunk(
  "event/mutate/status",
  async ({ id, status }: { id: number; status: EventStatus }, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };

    const { query, variables } = gqlBuilder.mutation({
      operation: "updateEventStatus",
      variables: {
        id: {
          name: "id",
          type: "ID!",
          value: parseInt(id + ""),
        },
        status: {
          name: "status",
          type: "EventStatus!",
          value: status,
        },
      },
      fields: ["id", "type", "status"],
    });

    try {
      const response = await client.mutate(
        "updateEventStatus",
        gql(query),
        variables,
      );

      return response as { id: number; status: string; type: string };
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const fetchEvents = createAsyncThunk(
  "event/mutate/fetch",
  async (date: Date, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };

    // Format the date to remove milliseconds
    const formattedDate = date.toISOString().replace(/\.\d{3}Z$/, "Z");

    const query = gql(`
      query {
          events(
              where: { allOf: [
                  {field: {created_at: {greaterThanOrEqual: "${formattedDate}"}}},
              ] }
              sort: {field: {created_at: Desc}}
          ) {
              data {
                  id
                  type
                  status
                  message
                  created_at
              }
          }
      }
  `);

    try {
      const response = await client.query("events", query);
      return response as {
        data: EventModel[];
      };
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const fetchEventsCount = createAsyncThunk(
  "event/mutate/fetchCount",
  async (_, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };

    const query = gql(`
      query {
        eventsCount
      }
    `);

    try {
      const response = await client.query("eventsCount", query);
      return response as number;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

const initialState = {
  events: [] as EventModel[],
  pollingActive: false,
  newEventsCount: 0,
};

const eventMutateSlice = createSlice({
  name: "tireSetMutate",
  initialState,
  reducers: {
    setPollingActive: (state, action) => {
      state.pollingActive = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchEvents.pending, (state) => {
      state.events = [];
    });
    builder.addCase(fetchEvents.fulfilled, (state, action) => {
      state.events = (action.payload as { data: EventModel[] }).data;
    });
    builder.addCase(fetchEventsCount.fulfilled, (state, action) => {
      state.newEventsCount = action.payload as number;
    });
  },
});

export const { setPollingActive } = eventMutateSlice.actions;

export default eventMutateSlice.reducer;
